<script setup>
import { ref } from 'vue'
import Pagination from '@/Shared/Pagination.vue'
import Portrait from '@/Shared/Portrait.vue'
import SearchInput from '@/Shared/SearchInput.vue'
import Icon from '@/Shared/Icon.vue'
import PersonCardGrid from '@/Shared/PersonCardGrid.vue'
import { Link } from '@inertiajs/vue3'

const props = defineProps({
  coaches: {
    type: Object,
    default: () => {}
  },
  filters: {
    type: Object,
    default: () => ({
      search: ''
    })
  }
})

const search = ref(props.filters.search)

const breadcrumbs = [{ label: 'Clases' }, { label: 'Entrenadores' }]

const badgeConfig = {
  field: 'is_admin',
  condition: true,
  trueText: 'Admin',
  falseText: '',
  trueIcon: 'Shield',
  falseIcon: null,
  trueClass: 'bg-indigo-100 text-indigo-800',
  falseClass: ''
}

const roleConfig = {
  field: 'is_admin',
  condition: true,
  trueText: 'Administrador',
  falseText: 'Entrenador'
}

const emptyState = {
  title: 'No hay entrenadores todavía',
  description: 'Crea un nuevo entrenador para comenzar a gestionar tu equipo técnico',
  buttonText: 'Nuevo entrenador',
  buttonUrl: '/coaches/create',
  icon: 'Warning'
}
</script>

<template>
  <Portrait
    title="Entrenadores"
    subtitle="Gestiona los entrenadores del club"
    :breadcrumbs="breadcrumbs"
  >
    <div class="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <SearchInput
        v-model="search"
        class="w-full sm:w-64"
        placeholder="Buscar entrenadores..."
        url="/coaches"
        :debounce-time="250"
        :only="['coaches']"
      />

      <Link class="btn-indigo flex items-center justify-center" href="/coaches/create">
        <Icon name="Plus" class="h-5 w-5 mr-2" />
        <span>Nuevo entrenador</span>
      </Link>
    </div>

    <PersonCardGrid
      :items="coaches.data"
      :nested-fields="true"
      nested-key="player"
      :badge-config="badgeConfig"
      :role-config="roleConfig"
      base-path="/coaches"
      :empty-state="emptyState"
    />

    <Pagination class="mt-6" :links="coaches.links" :preserve-state="true" :only="['coaches']" />
  </Portrait>
</template>
